module.exports = __webpack_public_path__ + "media/images/pic/polygon-camps-small-9e64c63718dfe496f8d18c5e819799d2.svg";